export async function loadEnLocale() {
  return await import('./translations/en.json')
}

export const languageMap = {
  en: loadEnLocale
}
